<!--
     <DateInput
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → Gives the field's serializable value

     Accepted props:
     - value
     - class
     - label
     - format
-->

<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-y
      max-width="300"
      :disabled="!!props.readonly"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="formatted_date"
          :label="props.label"
          :class="[props.class || 'qmkey-form-input', {'required':props.required}]"
          readonly
          v-bind="attrs"
          v-on="on"
          :rules="rules"
          outlined
          dense
          background-color="#f2f2f2"
          :clearable="!props.required"
          @click:clear="props.value=null"
        >
          <v-icon 
            slot="append"
            color="primary"
            v-bind="attrs"
            v-on="on"
          >
            {{ false || "mdi-calendar" }}
          </v-icon>
        </v-text-field>
      </template>
      <v-date-picker
        v-model="props.value"
        no-title
        @change="menu = false"
      ></v-date-picker>
    </v-menu>
  </div>
</template>


<script>

 import strftime from 'strftime'

 export default {
   name: 'DateInput',

   props: ['props'],

   data: (() => ({
     menu: false,
     valid:true
   })),

   computed: {
     formatted_date() {
       return this.value ? strftime(this.props.format || '%D', new Date(this.value))  : "";
     },

     value() {
       console.log('DateInput.value =', this.props.value);
       return this.props.value;
     },
     rules() {
      // TODO: Multilang: Change hardcoded string
      return [(value) => !!value || !this.props.required || 'Campo requerido']
    },
   },

   methods: {
     validate() {
       // TODO: Show error message
       return !this.props.required || !!this.value;
     },
     error_state(ok) {
      this.valid = ok
    },
   },

   watch: {
     value(date) {
       console.log(date);
       // If date is empty, default to current date
       if (!date && this.props.required)
          date = (new Date()).toISOString().split('T')[0];
          this.props.value = date
     },
   }
 }
</script>
<style lang="scss">
@import '@/sass/modalform.scss';
</style>